export type ServiceKey =
  | "Chat API"
  | "HR Agent Name API"
  | "Auth API"
  | "Files API"
  | "Emailer API";

type HealthStatus = "UP" | "DOWN" | "DEGRADED";

export type ServiceStatus = {
  key: ServiceKey;
  status: HealthStatus;
  uptime30d: number; // percent (e.g. 99.96)
  latencyMs?: number | null;
  incidents30d: number;
};

function StatusPill({ status }: { status: HealthStatus }) {
  const color =
    status === "UP"
      ? "bg-green-100 text-green-800"
      : status === "DOWN"
      ? "bg-red-100 text-red-800"
      : "bg-yellow-100 text-yellow-800";

  const dot =
    status === "UP"
      ? "bg-green-500"
      : status === "DOWN"
      ? "bg-red-500"
      : "bg-yellow-500";

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded-full ${color}`}
    >
      <span className={`w-2 h-2 rounded-full ${dot}`} />
      {status}
    </span>
  );
}

function ServiceStatusCards({ services }: { services: ServiceStatus[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
      {services.map((s) => (
        <div key={s.key} className="rounded-2xl border bg-white p-4 shadow-sm">
          <div className="flex items-start justify-between">
            <h4 className="text-sm font-semibold text-gray-900">{s.key}</h4>
            <StatusPill status={s.status} />
          </div>

          <dl className="mt-3 text-sm text-gray-600 space-y-1.5">
            <div className="flex justify-between">
              <dt>Uptime (30d)</dt>
              <dd className="font-semibold text-gray-900">
                {s.uptime30d.toFixed(2)}%
              </dd>
            </div>
            <div className="flex justify-between">
              <dt>Latency (ms)</dt>
              <dd className="font-semibold text-gray-900">
                {s.latencyMs != null ? (
                  Math.round(s.latencyMs)
                ) : (
                  <span className="text-gray-400">—</span>
                )}
              </dd>
            </div>
            <div className="flex justify-between">
              <dt>Incidents (30d)</dt>
              <dd className="font-semibold text-gray-900">{s.incidents30d}</dd>
            </div>
          </dl>
        </div>
      ))}
    </div>
  );
}

export default ServiceStatusCards;
